import styled from 'styled-components';
import { Row } from '../../styled';

export const ToolbarWrapper = styled(Row).attrs({ as: 'section' })`
    height: ${({ height }) => (height ? height : '40px')};
    width: 100%;
    background-color: ${({ theme }) => theme.bg.sportPrimary};
    justify-content: space-between;
    padding: 8px 16px;
    box-sizing: border-box;
    border-radius: 4px 4px 0 0;
    overflow: hidden;
`;

export const ToggleListWrapper = styled(ToolbarWrapper)`
    border-radius: ${({ expanded }) => (expanded ? '4px 4px 0px 0px;' : '4px')};
    padding: 8px 16px;
    cursor: pointer;

    .info-tooltip {
        opacity: 1 !important;
        z-index: 1;
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.5);
        text-align: left;
    }
`;

export const AndetToolbarWrapper = styled(ToolbarWrapper)`
    background-color: ${({ theme }) => theme.bg.secondaryWhite};
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;

    .fa.fa-angle-right {
        color: ${({ theme }) => theme.text.toolbarArrowDark};
        font-size: 18px;
        font-weight: bold;
    }
`;

export const ToolbarContent = styled(Row)`
    justify-content: flex-start;
    gap: 8px;
`;

export const LiveDot = styled.span`
    height: 12px;
    width: 12px;
    position: relative;
    background: ${({ theme }) => theme.text.liveRedDark};
    border-radius: 100%;
`;

export const ToolbarIcon = styled.img`
    width: 12px;
    height: 12px;
`;

export const ToolbarLink = styled.div`
    color: #fff;
    font-size: 10px;
    padding: 11px 10px;
    font-weight: 400;
    text-decoration: underline;
    margin: 0;
    cursor: pointer;
`;

export const ToolbarTitle = styled.h2`
    width: ${({ $width }) => $width || '100%'};
    margin: 0;
    font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : '14px')};
    line-height: 24px;
    font-weight: ${({ $fontWeight }) => ($fontWeight ? $fontWeight : 'normal')};
    color: ${({ theme }) => theme.text.white};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;

    img {
        vertical-align: middle;
        margin-left: 5px;
        line-height: 20px;
    }
`;

export const AndetToolbarTitle = styled(ToolbarTitle)`
    width: 80%;
    flex-grow: 1;
    font-size: 13px;
    font-weight: 700;
    line-height: 20px;
    color: ${({ theme }) => theme.text.toolbarNeutralDark};
`;

export const ToggleIcon = styled.div`
    text-align: center;
    line-height: 38px;
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.text.white};

    .fa {
        font-size: 18px;
        font-weight: bold;
    }
`;

export const BackButton = styled.div`
    color: #fff;
    font-size: 14px;
    padding: 10px;
    cursor: pointer;
`;

export const CloseButton = styled.div`
    color: #fff;
    font-size: 18px;
    padding: 15px;
    cursor: pointer;
`;

export const ToolbarSportIcon = styled.img`
    width: 20px;
    height: 20px;
    object-fit: contain;
`;
